import { about, learn } from "../../data/aboutCourse-data";
import { LearnCard } from "./cards";

function AboutCourseSection({ section, course }) {
  const title =
    course?.title || course?.groupName ? `About ${course?.title}` : about.title;
  const text = course?.about?.text || course?.description || about.text;
  const learnTitle = course?.learn?.title || learn.title;
  const learnDescription = course?.learn?.description;
  // Strapi's repeatable "learn" component is returned as an array of entries.
  // Keep support for the legacy nested shape and local fallback data as well.
  const learnItems = Array.isArray(course?.learn)
    ? course.learn
    : Array.isArray(learnDescription)
      ? learnDescription
      : learn.items;

  return (
    <section className="relative mx-auto py-10">
      {/* About */}
      {section !== "short-course" && (
        <div className="max-w-3xl">
          <h2 className="font-bold text-[28px] leading-9 tracking-normal text-[#1E1B2E] mb-4">
            {title}
          </h2>
          <p className="font-normal text-base leading-7 tracking-normal text-[#1E1B2E] whitespace-pre-line mb-10">
            {text}
          </p>
        </div>
      )}

      {/* Learn grid */}
      <div className="">
        <h3 className="font-bold text-[28px] leading-[36px] text-[#1E1B2E] mb-4">
          {learnTitle}
        </h3>

        {typeof learnDescription === "string" ? (
          <p className="font-normal text-base leading-7 tracking-normal text-[#1E1B2E] whitespace-pre-line">
            {learnDescription}
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
            {learnItems.map((item, i) => (
              <LearnCard
                key={i}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default AboutCourseSection;
